export default "/images/chevrons-up.svg?5d7c2212a761f8c08afd9c24a4f1fc12";